import React, { useEffect } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CloseImage from '../../assets/close.png';
import { useStyles, BootstrapInput } from '../../library/selectOption';
import { Checkbox, Divider, Typography, withStyles } from '@material-ui/core';


const CustomCheckbox = withStyles({
    root: {
        color: '#2a9c6c',
        '&$checked': {
            color: '#2a9c6c',
        },
        padding: 5,
        borderRadius: 20,
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default function SlotWaktu(props) {
    console.log(props);
    // GENERATE TIMESLOT 
    // console.log(waktu);

    let { start, end } = props.duration
    start = start.name.split(":")
    end = end.name.split(":")
    start = +start[0]
    end = +end[0]
    console.log(start, end);
    let timeSlot = []
    // for (let j = start; j<= end; j++) {
    //     let temp = {}
    //     for (let i = 0; i <= 45; i+= 15) {
    //         if (i === 0) {
    //             temp = {waktu: `${j}:${i}0 - ${j}:${i+15}`, checked: true}
    //             timeSlot.push(temp)
    //             temp = []
    //         } else {
    //             if (i + 15 !== 60) {
    //                 temp = {waktu: `${j}:${i} - ${j}:${i+15}`, checked: true}
    //             } else {
    //                 let k = j
    //                 console.log(j, i);
    //                 temp = {waktu: `${j}:${i} - ${j+1}:00`, checked: true}
    //             }
    //             timeSlot.push(temp)
    //             temp = {}
    //         }
    //         if (j === end && i === 0) {
    //             break;
    //         }
    //     }
    // }

    useEffect(() => {
        let waktu = props.dataApi
        waktu.forEach((el) => {
            el.is_checked = true
        })
        setListWaktu(waktu)
    }, [])

    const classes = useStyles();
    const [spesialis, setSpesialis] = React.useState("spesialis");
    const [checkedAll, setCheckedAll] = React.useState(true);
    const [pengalamanDokter, setPengalamanDokter] = React.useState(Number)
    const [listWaktu, setListWaktu] = React.useState([])

    console.log(pengalamanDokter, spesialis);

    const handleCheked = (index) => {
        if (listWaktu[index].is_checked === true) {
            listWaktu[index].is_checked = false
            console.log('masuk');
        } else {
            listWaktu[index].is_checked = true
        }
        let idx = listWaktu.findIndex((val) => val.is_checked === false)
        if (idx > -1) {
            setCheckedAll(false)
        } else {
            setCheckedAll(true)
        }
        console.log(listWaktu);
        forceUpdate()
    }

    const handleSelectAll = () => {
        listWaktu.forEach((el) => {
            el.is_checked = !checkedAll
            forceUpdate()
        })
        setCheckedAll(!checkedAll)
        console.log(listWaktu);
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ height: '100%', position: 'absolute', right: 0, width: 404, overflow: 'auto' }}>
                <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 0, borderTopLeftRadius: 0, backgroundColor: '#278863' }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'white', fontSize: 18, }}>Detail Slot Waktu</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 14, height: 14 }} />
                        </button>
                    </div>
                </div>
                <div style={{ padding: 20 }}>
                    <div style={{display: 'flex'}}>
                        <CustomCheckbox
                            
                            checked={checkedAll}
                            onChange={() => handleSelectAll()}
                        />
                        {checkedAll === false ?
                            <Typography style={{marginLeft: 10, marginTop: 6, width: '100%', textAlign: 'left'}}>Select All</Typography>
                            : 
                            <Typography style={{marginLeft: 10, marginTop: 6, width: '100%', textAlign: 'left'}}>Unselect All</Typography>
                        }
                    </div>
                    {listWaktu.map((item, index) => {
                        console.log(item);
                        return (
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                <CustomCheckbox
                                    checked={item.is_checked}
                                    onChange={() => handleCheked(index)}
                                />
                                <div style={{ marginLeft: 20, width: '100%', textAlign: 'left' }}>
                                    <span style={{}}>{item.detail_time_start.slice(0, 5)} - {item.detail_time_end.slice(0, 5)}</span>
                                </div>
                                {
                                    item.is_available === 1 ?
                                    <Typography style={{fontSize: 10, paddingRight: 60, width: 300, color: '#A4A4A4'}}>Belum Ada Reservasi</Typography>
                                    : <Typography style={{fontSize: 10, paddingRight: 60, width: 300, color: '#A4A4A4'}}>Jadwal Sudah Ada</Typography>
                                }
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}